import * as React from 'react';
import {
	Degree,
	EducationEntryWrapper,
	School,
	Speciality,
	TimelineContent,
	TimelineMarker
} from './EducationStyles';
import {language} from './EducationLanguage';

export type Props = {
	entry: any
};

export const EducationEntryLayout = (props: Props) =>
{
	const render = () =>
	{
		const returnValue = (
			<EducationEntryWrapper>
				<TimelineMarker />
				<TimelineContent>
					<Degree>{props.entry.degree}</Degree>
					<School>{props.entry.school}</School>
					<Speciality>{props.entry.speciality}</Speciality>
				</TimelineContent>
			</EducationEntryWrapper>
		);
		// <EducationEntryWrapper>
		// 		<Degree>
		// 			{props.entry.degree}
		// 		</Degree>
		// 		<School>
		// 			{props.entry.school}
		// 		</School>
		// 		<Speciality>
		// 			{props.entry.speciality}
		// 		</Speciality>
		// 	</EducationEntryWrapper>
		// );
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
